// "Add enquiry": a family that phoned or emailed before filling in any form.

import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";
import type { CrmEnquiry } from "../../shared/crm";

const blank = (today: string): CrmEnquiry => ({
  parentName: "", email: "", phone: "", address: "", childName: "", childDateOfBirth: null, interest: "preschool", date: today,
});

export const EnquiryDialog: React.FC<{ open: boolean; today: string; onClose: () => void; onSave: (enquiry: CrmEnquiry) => void }> =
  ({ open, today, onClose, onSave }) => {
    const [value, setValue] = useState<CrmEnquiry>(blank(today));
    useEffect(() => { if (open) setValue(blank(today)); }, [open, today]);
    const set = (field: keyof CrmEnquiry) => (e: React.ChangeEvent<HTMLInputElement>) => setValue({ ...value, [field]: e.target.value || (field === "childDateOfBirth" ? null : "") });
    const valid = value.parentName.trim() && (value.email.trim() || value.phone.trim());
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>New enquiry</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <ToggleButtonGroup exclusive size="small" value={value.interest} onChange={(_, interest) => interest && setValue({ ...value, interest })}>
              <ToggleButton value="preschool">Preschool</ToggleButton>
              <ToggleButton value="holiday">Holiday Club</ToggleButton>
              <ToggleButton value="both">Both</ToggleButton>
            </ToggleButtonGroup>
            <TextField label="Parent name" required value={value.parentName} onChange={set("parentName")} autoFocus />
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <TextField label="Email" type="email" fullWidth value={value.email} onChange={set("email")} />
              <TextField label="Phone" fullWidth value={value.phone} onChange={set("phone")} />
            </Stack>
            <TextField label="Address or postcode" value={value.address} onChange={set("address")} />
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <TextField label="Child's name" fullWidth value={value.childName} onChange={set("childName")} />
              <TextField label="Child's date of birth" type="date" fullWidth InputLabelProps={{ shrink: true }}
                value={value.childDateOfBirth ?? ""} onChange={set("childDateOfBirth")} />
            </Stack>
            <TextField label="Enquiry date" type="date" InputLabelProps={{ shrink: true }} value={value.date} onChange={set("date")} />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" disabled={!valid} onClick={() => onSave({
            ...value,
            parentName: value.parentName.trim(), email: value.email.trim(), phone: value.phone.trim(),
            address: value.address.trim(), childName: value.childName.trim(),
          })}>Add</Button>
        </DialogActions>
      </Dialog>
    );
  };
